import { getAuth, getIdTokenResult } from 'firebase/auth';
import { App, ConnectApi, ConnectLinkWithReferralHash, UserRole } from 'hydra-data-types';
import { createHcpPatientLink } from './AuthApi';

/**
 * Referral links route to the patient consent screen regardless of who is currently signed
 * in. If a different account (e.g. an HCP's own session) is still active in the browser when
 * a patient referral link loads, this must not link that account to the HCP - it signs that
 * session out instead of proceeding.
 */
export async function linkPatientToHcp(args: {
  hcpReferralHash: string | undefined;
}): Promise<ConnectApi.ConnectUserAndProfile> {
  const currentUser = getAuth().currentUser;
  const { claims } = currentUser ? await getIdTokenResult(currentUser, true) : { claims: {} };

  if (claims[UserRole.NervaUser] !== true) {
    await getAuth().signOut();
    throw new Error('Signed-in user is not a patient');
  }

  return await createHcpPatientLink({
    hcpReferralHash: args.hcpReferralHash,
    patientConsent: false,
    patientProduct: App.Nerva,
  } as ConnectLinkWithReferralHash);
}
